import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export const productService = {
    getAll,
    getSample,
    getById,
    getByTags,
    getByKeyword,
    getBySlug,
    create,
    update,
    remove,
    search,
    getAllProducts,
    getProductBySlug,
    getAlsoBought
};

function create(body){

    body.slug = body.name.replace(/^\s+|\s+$/g, '').toLowerCase();
    body.sale = body.sale || false;
    body.new = body.new || false;

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };
    
    return fetch(Config.api.basepath+`/product`, requestOptions).then(handleResponse)
}

 function update(body) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/product/`+body._id, requestOptions).then(handleResponse);
}

function getSample(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/product/sample`, requestOptions)
        .then(handleResponse)
        .then(
            products => {
                return products;
            },
            error => {
                return {error: 'Fetch Menu Error. Service Unavailable.'};
            }
        );
}

function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/product?`;

    url = options.page ? url + `page=` + options.page : url
    url = options.items ? url + `&per-page=` + options.items : url
    url = options.limit ? url + `&limit=` + options.limit : url;

    let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
        return r.concat(k + ':' + options.filter[k]);
    }, []);

    let sort = options.sort && Object.keys(options.sort).reduce(function (r, k) {
        return r.concat(k + ':' + options.sort[k]);
    }, []);


    url = options.filter ? url + `&filter=` + filter : url;
    url = options.sort ? url + `&sort=` + sort : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            products => {
                let pages = parseInt(products.total / products['per-page']);
                pages = products.total > ( pages * products['per-page'] ) ? pages + 1 : pages;

                products.pages = pages;

                return products;
            },
            error => {
                return {error: 'Fetch Products Error. Service Unavailable.'};
            }
        );
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/product/`+id, requestOptions).then(handleResponse);
}

function getBySlug(slug) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/product/slug/`+slug, requestOptions).then(handleResponse);
}

function getByTags(tag) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/product/tags?keyword=`+tag, requestOptions).then(handleResponse)
}
// function getByTags(tags) {
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };

//     return fetch(Config.api.basepath+`/product/?filter=tags:`+tags, requestOptions).then(handleResponse);
// }

function getByKeyword(key) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/product/search?keyword=`+key, requestOptions).then(handleResponse)
}

function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/product/`+id, requestOptions).then(handleResponse);
}

function search(item, page, perPage) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    // const post = post ? post.replace(' ', '%20') : '';

    const _pageNum = page || 1;
    const _perPage = perPage || Config.pagination.limit;
    
    return fetch(Config.api.basepath+`/product?page=${_pageNum}&per-page=${_perPage}&search=name:${item}`, requestOptions).then(handleResponse)  
}

function formatPrice(price) {
    if (typeof price === 'number') {
        return price;
    }
    // Remove non-numeric characters except the decimal point
    const numericPrice = parseFloat(price.replace(/[^\d.]/g, ''));
    return numericPrice;
}

function getAllProducts(categoryOne, selectedTags, minPrice, maxPrice, page = 1, perPage = 10, searchQuery = '') {
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/wp-json/wc/v3/products`;

    let queryParams = [];

    if (categoryOne) {
        queryParams.push(`category=${categoryOne}`);
    }

    if (selectedTags && selectedTags.length > 0) {
        const tagsQueryParam = selectedTags.join(',');
        queryParams.push(`tag=${tagsQueryParam}`);
    }

    if (minPrice !== undefined) {
        const formattedMinPrice = formatPrice(minPrice);
        queryParams.push(`min_price=${formattedMinPrice}`);
    }

    if (maxPrice !== undefined && maxPrice !== Infinity) {
        const formattedMaxPrice = formatPrice(maxPrice);
        queryParams.push(`max_price=${formattedMaxPrice}`);
    }

    if (searchQuery) {
        queryParams.push(`search=${encodeURIComponent(searchQuery)}`);
    }

    queryParams.push(`page=${page}`);
    queryParams.push(`per_page=${perPage}`);

    if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
    }

    const requestConfig = {
        method: 'GET',
        headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
    };

    return fetch(url, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch products');
            }
            return response.json();
        });
}



function getProductBySlug(slug) {
    const baseUrl = window.location.origin;
    const url = baseUrl + Config.api.basepath + `/wc/v3/products?slug=${slug}`;
    console.log("getProductBySlug", url)
    const requestConfig = {
        method: 'GET',
        headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
    };

    return fetch(Config.api.basepath + `/wc/v3/products?slug=${slug}`, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch products');
            }
            return response.json()
        })
        .then(res => { 
            return res[0] })
        .catch(err => console.log(err))
          
 
}

function getAlsoBought({limit}){
    const baseUrl = window.location.origin;
    const url = baseUrl + Config.api.basepath + `/wc/v3/products?orderby=rand&per_page=${limit}`;
    console.log("getAlsoBought", url)
    const requestConfig = {
        method: 'GET',
        headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
    };
  
     return fetch(Config.api.basepath + `/wc/v3/products?orderby=rand&per_page=${limit}`, requestConfig)
     .then(response => {
         if (!response.ok) {
             throw new Error('Failed to fetch products');
         }
         return response.json()
     })
     .then(res => { 
        return res
    })
}

function oauthFunction() {
    
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });


    return oauth
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {

            let error = (data && data.message) || response.statusText;

            if( data.error && data.error.code === 11000){
                error = 'product already exists.';
            }

            return Promise.reject(error);
        }

        return data;
    });
}